import React, { useEffect, useState } from "react"
import { FormattedMessage } from "react-intl"
import { InvoiceDto } from "../../../state/invoice/models"
import Invoice from "../../../state/invoice/models/invoice"
import Proposal from "../../../state/proposal/Proposal"
import Integrations from "../../../integration/Integrations"
import { EventObjectDto } from "../../../state/event/Event"
import { InvoiceService } from "../../../state/invoice/services"
import GlobalHelper from "../../../common/GlobalHelper"
import { BILLING_TYPE } from"../../../state/invoice/InvoiceBillingType"

const IntegrationKey = "shopify-expert-app"
type OwnProps = {
    object: EventObjectDto
    invoice: InvoiceDto
    proposal: Proposal
}

const InvoiceExportedToShopifyExpertAppEvent = (props: OwnProps) => {
    const [parentInvoiceExternalLink, setParentInvoiceExternalLink] = useState<string>("")
    let type = props.object.attributes.entityType


    useEffect(() => {
        fetchParentInvoice()
    }, [])

    const fetchParentInvoice = async () => {
        const parentInvoiceId = props.invoice.attributes.returnOfInvoiceId
        if (parentInvoiceId) {
            const res = await InvoiceService.get(parentInvoiceId)
            const invoice = res as Invoice
            const link = GlobalHelper.getObjectExternalLink(invoice.getInvoiceDto(), IntegrationKey)
            if (link) {
                setParentInvoiceExternalLink(link)
            }
        }
    }

    const renderMessage = () => {
        if (isStandaloneReturn()) {
            type = "inventory-adjustment"
        }
        switch (type) {
        case "main":
            return !isReturn() ?
                <FormattedMessage
                    id="invoice.analytics.events.exported.shopify.text"
                    defaultMessage="Invoice {identifier} has been exported to Shopify as a completed order"
                    values={{
                        identifier: <strong>{props.invoice.attributes.identifier}</strong>,
                    }}
                /> : <FormattedMessage
                    id="invoice.analytics.events.return_exported.shopify.text"
                    defaultMessage="Return {identifier} has been exported to Shopify as a completed order"
                    values={{
                        identifier: <strong>{props.invoice.attributes.identifier}</strong>,
                    }}
                />
        case "void":
            return <FormattedMessage
                id="invoice.analytics.events.exported.shopify.void_text"
                defaultMessage="Invoice {identifier} has been refunded in Shopify"
                values={{
                    identifier: <strong>{props.invoice.attributes.identifier}</strong>,
                }}
            />
        case "invoice-adjustment":
        case "payment-adjustment":
            return <span>
                <FormattedMessage
                    id="invoice.analytics.events.exported.shopify.adjustment_text"
                    defaultMessage="An adjustment for {identifier} has been made in Shopify"
                    values={{
                        identifier: <strong>{props.invoice.attributes.identifier}</strong>,
                    }}
                />
                {props.object.attributes.metadata && props.object.attributes.metadata.notes &&
                        <span className={"ml-1"}>
                            <span className={"mr-1"}>/</span>
                            <FormattedMessage
                                id="invoice.analytics.events.exported.shopify.invoice_adjustment_notes"
                                defaultMessage="Reason: {notes}"
                                values={{
                                    notes: props.object.attributes.metadata.notes,
                                }}
                            />
                        </span>}
            </span>
        case "inventory-adjustment":
            return (
                <FormattedMessage
                    id="invoice.analytics.events.exported.shopify.standalone_return_inventory_adjustment"
                    defaultMessage="Return exported to shopify as inventory adjustment"
                />
            )

        }
        return ""

    }

    const isReturn = (): boolean => {
        return props.invoice && props.invoice.attributes.billingType === BILLING_TYPE.RETURN
    }

    const isStandaloneReturn = (): boolean => {
        return isReturn() && !props.invoice.attributes.returnOfInvoiceId
    }

    const shopifyUrl = isReturn() ?
        Integrations.getPaymentTransactionExternalUrl(parentInvoiceExternalLink) :
        Integrations.getPaymentTransactionExternalUrl(props.object)

    return (
        <div className={"row"}>
            <div className={"col-12"}>
                <p className={"mb-2"}>
                    {renderMessage()}
                </p>
            </div>

            <div className={"col-12 d-flex align-items-center flex-wrap"}>
                <div className={"mr-3"}>
                    <a href={shopifyUrl} target="_blank" rel="noreferrer">
                        {Integrations.getIntegrationLogoImage(IntegrationKey, 75, 50)}
                    </a>
                </div>
                {shopifyUrl &&
                    <div className={""}>
                        <p className={"mb-0"}>
                            <a href={shopifyUrl} target={"_blank"} className={"btn btn-sm btn-outline-primary"} rel="noreferrer">
                                <FormattedMessage
                                    id="invoice.analytics.events.exported.shopify.open"
                                    defaultMessage="Open order in shopify"
                                />
                            </a>
                        </p>
                    </div>
                }
            </div>
        </div>
    )
}


export default InvoiceExportedToShopifyExpertAppEvent



// WEBPACK FOOTER //
// ./src/quote/analytics/events/invoice-exported-shopify-expert-app.component.tsx